import React from 'react'
import './Notificaciones.css'
import { MiFooter } from '../../components/footer/MiFooter';
import { ContentBodyNotificaciones } from '../../components/noTificaciones/ContentBodyNotificaciones'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const Notificaciones = () => {

  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }
  return (
    <div className='miNotificaciones' onClick={closeMenu} >
      <div className='headerNotificaciones'>
        <HeaderHome />
      </div>
      <div className="bodyNotificaciones">
        <ContentBodyNotificaciones />
      </div>
      <div className='footerNotificaciones'>
        <MiFooter />
      </div>
    </div>
  )
}
